/**
 * Contabilidade — peças visuais compartilhadas pelas telas da área (mesma cara
 * do Resultado por Plano, para quem navega entre elas não estranhar).
 */
import React from "react";

export const T = {
  bg: "#f5f7fa", card: "#ffffff", ink: "#2c3e50", inkSoft: "#7f8c8d", line: "#e8e8e8",
  teal: "var(--brand, #20a490)", tealSoft: "#e8f6f4", risco: "#e74c3c", riscoSoft: "#fdecea",
  ambar: "#f39c12", ambarSoft: "#fef5e7", azul: "#3498db", verde: "#27ae60",
};
export const MONO = "'SF Mono','JetBrains Mono',Consolas,monospace";

// Tooltip ⓘ: o compartilhado (portal — não é cortado por tabela com rolagem).
export { default as InfoTip } from "../../components/InfoTip";

export const Card = ({ children, style }) => (
  <div style={{ background: T.card, border: `1px solid ${T.line}`, borderRadius: 12, padding: 20, ...style }}>{children}</div>
);

export const Botao = ({ children, onClick, primario, disabled, pequeno }) => (
  <button onClick={onClick} disabled={disabled} style={{
    display: "inline-flex", alignItems: "center", gap: 6, padding: pequeno ? "5px 10px" : "8px 14px",
    borderRadius: 8, fontSize: pequeno ? 12 : 13, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
    border: primario ? "none" : `1px solid ${T.line}`, background: primario ? T.teal : "#fff",
    color: primario ? "#fff" : T.ink, opacity: disabled ? 0.6 : 1 }}>{children}</button>
);

export const TH = { padding: "8px 8px", fontWeight: 600, position: "sticky", top: 0, background: "#fff", fontSize: 12, color: T.inkSoft, borderBottom: `1px solid ${T.line}` };
export const TD = { padding: "6px 8px", color: T.ink, fontSize: 13, borderBottom: `1px solid ${T.line}` };

export const fmt = (v) => Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtInt = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
export const fmtPct = (v, casas = 1) => (v === null || v === undefined ? "—"
  : (v * 100).toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas }) + "%");
